import React from 'react';
import { connect } from 'react-redux'
import AltaModUsuario from './AltaModUsuario';

////Importación de actions.
import {
    getData,
    addProductoUsuario,
    getPerfilesByProducto,
    limpiarPerfilesFiltrados,
    createPerfil,
    addPerfilUsuario,
    deletePerfilUsuario,
    addPermiso,
    deletePermiso,
    selectProductoPermiso,
    selectCategoriaPermiso,
    selectProgramaPermiso,
    addFuncion,
    removeFuncion,
    addModoExclusivo,
    deleteModoExclusivo,
    setAccesosSimultaneosPorPlataforma,
    createUsuario,
    updateInformacionUsuario,
    cancelClick,
    resetState,
    hidePopUp,
    editUsuario,
    passWordChange,
    passWordUnChange,
    addGroupWindows,
    deleteGroupWindows,
    resetGrupoWindows
} from '../actions/AltaModUsuario';

const mapStateToProps = (state) => {
    return {
        data: state.altaModUsuario,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getData: (userToEditId, currentScope) => {
            dispatch(getData(userToEditId, currentScope));
        },
        getPerfilesByProducto: (productoId) => {
            dispatch(getPerfilesByProducto(productoId));
        },
        limpiarPerfilesFiltrados: () => {
            dispatch(limpiarPerfilesFiltrados());
        },
        createPerfil: (nombre, descripcion, productoId) => {
            dispatch(createPerfil(nombre, descripcion, productoId));
        },
        addPerfilUsuario: (perfilCodigo, productId) => {
            dispatch(addPerfilUsuario(perfilCodigo, productId));
        },
        deletePerfilUsuario: (perfilId) => {
            dispatch(deletePerfilUsuario(perfilId));
        },
        addPermiso: () => {
            dispatch(addPermiso());
        },
        deletePermiso: (permisoId) => {
            dispatch(deletePermiso(permisoId));
        },
        selectProductoPermiso: (idPermiso, idProducto) => {
            dispatch(selectProductoPermiso(idPermiso, idProducto));
        },
        selectCategoriaPermiso: (idPermiso, idCategoria) => {
            dispatch(selectCategoriaPermiso(idPermiso, idCategoria));
        },
        selectProgramaPermiso: (idPermiso, idPrograma) => {
            dispatch(selectProgramaPermiso(idPermiso, idPrograma));
        },
        addFuncion: (idPermiso, idFuncion, flag) => {
            dispatch(addFuncion(idPermiso, idFuncion, flag));
        },
        removeFuncion: (idPermiso, idFuncion) => {
            dispatch(removeFuncion(idPermiso, idFuncion));
        },
        addModoExclusivo: (modoExclusivo) => {
            dispatch(addModoExclusivo(modoExclusivo));
        },
        deleteModoExclusivo: (modoExclusivo) => {
            dispatch(deleteModoExclusivo(modoExclusivo));
        },
        setAccesosSimultaneosPorPlataforma: (plataformaId, plataforma) => {
            dispatch(setAccesosSimultaneosPorPlataforma(plataformaId, plataforma));
        },
        createUsuario: () => {
            dispatch(createUsuario());
        },
        editUsuario: () => {
            dispatch(editUsuario());
        },
        updateInformacionUsuario: (propToUpdate, value) => {
            dispatch(updateInformacionUsuario(propToUpdate, value));
        },
        cancelClick: () => {
            dispatch(cancelClick());
        },
        resetState: () => {
            dispatch(resetState());
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        },
        passWordChange: () => {
            dispatch(passWordChange());
        },
        passWordUnChange: () => {
            dispatch(passWordUnChange());
        },
        addProductoUsuario: (productoCodigo) => {
            dispatch(addProductoUsuario(productoCodigo));
        },
        addGroupWindows: (grupo) => {
            dispatch(addGroupWindows(grupo));
        },
        deleteGroupWindows: (grupo) => {
            dispatch(deleteGroupWindows(grupo));
        },
        resetGrupoWindows: () => {
            dispatch(resetGrupoWindows());
        }
    }
}

const AltaModUsuarioContainer = connect(mapStateToProps, mapDispatchToProps)(AltaModUsuario);

export default AltaModUsuarioContainer;
